import { defineStore } from 'pinia';
import i18n from '@/i18n';
import customersAPI from '@/services/CustomersService';

export const useStore = defineStore({
  id: 'lang',

  state: () => {
    return {
      languageInUse: 'none',
    };
  },
  getters: {
    languageCode(): string {
      return this.languageInUse;
    },
  },
  actions: {
    setLanguageLocale(locale: string) {
      this.languageInUse = locale;
      i18n.locale = this.languageInUse;
    },
    async setDefaultTranslations(){
      if (process.env.VUE_APP_USE_LOCAL_TRANSLATIONS === 'false') {
        const translationsJson = await customersAPI.getTranslations('en');
        i18n.setLocaleMessage('en', translationsJson.data);
      } 
    }
  },
});

declare const window: Window & {
  setLanguageLocale: (locale: string) => void;
};

/**
 * Dispose this on window global, for demoing purposes
 * @param locale language locale string
 */
window.setLanguageLocale = (locale: string) => {
  i18n.locale = locale;
};
